export default __webpack_public_path__ + "static/media/contact.b2278b9f.jpg";